export default "__VITE_ASSET__UtZa1PBT__"